import { render, staticRenderFns } from "./tripartiteLink.vue?vue&type=template&id=fb780202&scoped=true&"
import script from "./tripartiteLink.vue?vue&type=script&lang=js&"
export * from "./tripartiteLink.vue?vue&type=script&lang=js&"
import style0 from "./tripartiteLink.vue?vue&type=style&index=0&id=fb780202&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb780202",
  null
  
)

export default component.exports